<template>
  <v-dialog v-model="show" fullscreen>
    <v-card flat>
      <v-container fluid style="padding-bottom:100px">
        <div class="dialog-toolbar">
          <v-col cols="9" md="11">
            <h3>Negación al pago</h3>
          </v-col>
          <v-col cols="1" md="1" class="pull-right-on-desktop">
            <v-icon
              @click="$emit('close-dialog')"
              style="transform: translateX(-15px)"
              >close</v-icon
            >
          </v-col>
        </div>
        <div style="height: 50px;" class="mb-6"></div>
        <v-row v-if="!rejection.id">
          <v-col cols="12" md="4" offset-md="4">
            <v-btn @click="rejection.id = 11" large block color="rapired" dark
              >no puedo darle solución</v-btn
            >
          </v-col>
          <v-col cols="12" md="4" offset-md="4">
            <v-btn @click="rejection.id = 12" large block color="rapired" dark
              >el cliente no quiso</v-btn
            >
          </v-col>
          <v-col cols="12" md="4" offset-md="4">
            <v-btn @click="rejection.id = 14" large block color="rapired" dark
              >otros</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" md="4" offset-md="4">
            <v-btn
              @click="rejection = { id: null, reason: null }"
              large
              text
              color="rapired"
              ><v-icon color="rapired">arrow_back</v-icon>volver</v-btn
            >
          </v-col>
          <v-col cols="12" md="4" offset-md="4">
            <v-textarea
              autofocus
              v-model="rejection.reason"
              label="Descripción"
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="4" offset-md="4">
            <v-btn
              :disabled="!rejection.reason"
              @click="save"
              large
              block
              color="rapired"
              :dark="!!rejection.reason"
              >guardar</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean,
    visitId: Number
  },
  data() {
    return {
      rejection: {
        id: null,
        reason: null
      }
    };
  },
  methods: {
    save() {
      if (this.rejection.id) {
        this.axios
          .post(`/visit/${this.visitId}/status/`, this.rejection)
          .then(() => {
            this.$emit("reject-charge");
            console.log("HERE");
            this.$emit("close-dialog");
          });
      }
    }
  }
};
</script>
<style scoped>
@media (min-width: 960px) {
  .pull-right-on-desktop {
    display: flex;
    justify-content: flex-end;
  }
}
.bottom-bar {
  position: fixed;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 88px;
  display: flex;
  justify-content: flex-end;
}
.pb24 {
  padding-bottom: 84px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.date {
  text-transform: capitalize;
  text-align: left;
}
.status-name-cont {
  height: 30px;
  background: #c8272a;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
  text-transform: capitalize;
}
</style>
